import * as PIXI from 'pixi.js';
import { PoolGroup } from 'framework/utils/PoolGroup';
import { IPoint } from 'framework/utils/math-utils';
import { fillAnimationDependencies } from 'js/bubbleCore/view/animations/fillAnimationDependencies';
import { IAnimationDependencies, IAnimation } from 'js/bubbleCore/view/animations/types';
import { TweenManager } from 'framework/TweenManager/TweenManager';
import { Layout } from 'js/layouts/GameBoardLayout';
import { BubbleColor } from 'js/bubbleCore/bubbles/types';

const colorAssetMap: { [key in BubbleColor]: string } = {
  [BubbleColor.A]: '0_bubble_blue',
  [BubbleColor.B]: '0_bubble_green',
  [BubbleColor.C]: '0_bubble_pink',
  [BubbleColor.D]: '0_bubble_red',
  [BubbleColor.E]: '0_bubble_turquoise',
  [BubbleColor.F]: '0_bubble_yellow',
  [BubbleColor.NONE]: 'warning_bubble_2',
};
const burstAnimationLength = 5;

// animations
import { createSplashAnimation } from 'js/bubbleCore/view/animations/splashAnimation';
import { createBubbleBurst } from 'js/bubbleCore/view/animations/bubbleBurst';
import { createFireParticle } from 'js/bubbleCore/view/animations/fireParticle';
import { createShockwave } from 'js/bubbleCore/view/animations/shockwave';

export enum Layer {
  AboveGrid,
}

export class BoardAnimationLayer {
  private readonly animDep: IAnimationDependencies;
  private readonly layout: Layout;

  constructor(layout: Layout, tweenMgr?: TweenManager) {
    this.layout = layout;
    this.animDep = fillAnimationDependencies({tweenMgr});
  }

  public createBubbleBurst(color: BubbleColor): IAnimation {
    return createBubbleBurst(this.getKillTextures(color), this.animDep);
  }

  public createSplashAnimation(color: BubbleColor): IAnimation {
    return createSplashAnimation(`${colorAssetMap[color]}_splash`, this.animDep);
  }

  public createFireParticle(): IAnimation {
    return createFireParticle(this.animDep)
  }

  public createShockwave(): IAnimation {
    return createShockwave(this.animDep);
  }

  public addToLayer(displayObject: PIXI.DisplayObject, globalPosition: PIXI.PointLike, layer: Layer): void {
    const container = this.getContainerForLayer(layer);
    const targetPX = container.toLocal(globalPosition);
    displayObject.position.copy(targetPX);
    container.addChild(displayObject);
  }

  private getKillTextures(color: BubbleColor): PIXI.Texture[] {
    const result: PIXI.Texture[] = [];
    const asset = colorAssetMap[color];
    for (let i = 1; i <= burstAnimationLength; i++) {
      result.push(PIXI.Texture.from(`${asset}_${i}`));
    }
    return result;
  }

  private getContainerForLayer(layer: Layer): PIXI.Container {
    return {
      [Layer.AboveGrid]: this.layout.fxAboveGrid,
    }[layer];
  }
}